import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const FLYER_URL =
  "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/40zuhlsb_e7d7b837-8e4a-45a2-8ef6-6086d2300250.png";

const ServiceArea = () => {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="eyebrow mb-4">Actief in jouw regio</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight">
            Kieldrecht als <span className="italic text-gold">uitvalsbasis.</span>
          </h2>
          <p className="mt-5 text-neutral-600 text-sm max-w-lg mx-auto leading-relaxed">
            Gratis verplaatsing tot 10 km vanaf Marktplein 29, 9130 Kieldrecht.
            Woon je verder? Geen probleem — we vinden vast een oplossing.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="max-w-5xl mx-auto shadow-2xl"
        >
          <img
            src={FLYER_URL}
            alt="Actief in jouw regio — Lenslopers Fotografie, 10 km radius vanaf Kieldrecht"
            className="w-full h-auto block"
            loading="lazy"
          />
        </motion.div>

        <p className="mt-12 text-center font-script text-gold text-3xl md:text-4xl">
          <Heart size={12} className="inline text-gold mr-3 mb-2" fill="currentColor" strokeWidth={0} />
          Kieldrecht als uitvalsbasis, prachtige herinneringen overal
          <Heart size={12} className="inline text-gold ml-3 mb-2" fill="currentColor" strokeWidth={0} />
        </p>
      </div>
    </section>
  );
};

export default ServiceArea;
